import React from 'react';

/**
 * Universal modal wrapper for consistent modal UI
 * Props: open, onClose, title, children, width
 */
const Modal = ({ open, onClose, title, children, width = 420 }) => {
  if (!open) return null;
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div
        className="modal universal-modal"
        style={{ minWidth: width, maxWidth: '98vw' }}
        onClick={e => e.stopPropagation()}
      >
        {title && <h3>{title}</h3>}
        {children}
        <button className="close-btn" onClick={onClose} style={{marginTop:18}}>Хаах</button>
      </div>
    </div>
  );
};

export default Modal;
